var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnion0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 45C34.9264 45 45 34.9264 45 22.5C45 10.0736 34.9264 0 22.5 0C10.0736 0 0 10.0736 0 22.5C0 34.9264 10.0736 45 22.5 45ZM18.8217 10.7189C19.9834 10.3566 21.2188 10.1614 22.4998 10.1614C29.3142 10.1614 34.8385 15.6856 34.8385 22.5001C34.8385 27.6108 31.7312 31.9959 27.3028 33.8691C31.7313 31.996 34.8387 27.6109 34.8387 22.5C34.8387 15.6855 29.3145 10.1613 22.5 10.1613C21.2189 10.1613 19.9834 10.3565 18.8217 10.7189Z",
    fill: "url(#paint0_linear_10676_8257)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10676_8257",
    x1: 6.87097,
    y1: 6.04839,
    x2: 43.8871,
    y2: 43.0645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4A938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B36C02"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion0);
export default __webpack_public_path__ + "static/media/union0.6b6413cb9a6cf062e1b7e447bf9abbb2.svg";
export { ForwardRef as ReactComponent };